import { useFeatureFlagVariantKey } from 'posthog-js/react'
import { FeatureFlagEnum } from '@vacationtracker/shared/types/feature-flags'

import { mapPosthogVariantKeyToOnboardingCallCtaVariant, OnboardingCallCtaVariantId } from './onboarding-call-cta-variant'

/** A/B variant for onboarding call CTA - PostHog multivariate flag `onboarding-call-cta-ab` only. */
export function useOnboardingCallCtaVariant(): OnboardingCallCtaVariantId {
  const raw = useFeatureFlagVariantKey(FeatureFlagEnum.onboardingCallCtaAb)
  return mapPosthogVariantKeyToOnboardingCallCtaVariant(raw)
}
